module.exports = __webpack_public_path__ + "static/media/Fishfry.98932bdf.jpg";